import React from "react";
import { downloadPDF } from "../ChartsJs/DownlaodExportImage";
import { LoginURL } from "./axios_helper";

export const ValidateForm = (e) => {
  let err = {};
  e.currentTarget
    .querySelectorAll('[data-required="true"]')
    .forEach((element) => {
      if (!element.value.trim()) {
        err[element.name] = true;
      } else if (element.value.trim() == "0") {
        err[element.name] = true;
        err["Zero"] = true;
      }
    });

  return Object.keys(err).length > 0 ? err : null;
};

export const GetFormData = (e) => {
  let formData = new FormData(document.getElementById(`${e.currentTarget.id}`));
  let obj = Array.from(formData.entries()).reduce((a, c) => {
    a[c[0]] = c[1];
    return a;
  }, {});
  return obj;
};

export const GetFormDataById = (id) => {
  let formData = new FormData(document.getElementById(`${id}`));
  let obj = Array.from(formData.entries()).reduce((a, c) => {
    a[c[0]] = c[1];
    return a;
  }, {});
  return obj;
};

export const Loader = () => {
  return (
    <>
      <div className="preloader-bg"></div>
      <div id="preloader">
        <div id="preloader-status">
          <div className="preloader-position loader">
            <span></span>
          </div>
        </div>
      </div>
    </>
  );
};

export const Button = ({
  name,
  id,
  isCancelButton,
  className,
  onClick,
  dataBsToggle,
  dataBsTarget,
  dataBsDismiss,
  icon,
  styles,
}) => {
  let btnClass = "butn-dark2";
  let btnType = "submit";

  if (isCancelButton) {
    btnClass = btnClass + " grey-btn m-2";
    btnType = "button";
  }

  if (!isCancelButton && dataBsToggle && dataBsTarget) {
    return (
      <button
        id={id || ""}
        type={btnType}
        className={btnClass}
        onClick={onClick}
        data-bs-toggle={dataBsToggle}
        data-bs-target={dataBsTarget}
      >
        <span>{name}</span>
      </button>
    );
  }
  return (
    <button
      id={id || ""}
      type={btnType}
      className={btnClass}
      onClick={onClick}
      data-bs-dismiss={dataBsDismiss}
      style={styles}
    >
      <span>
        {name}
        {icon}
      </span>
    </button>
  );
};

export const CommonErrorMsg = ({ text, IsError }) => {
  return (
    <span
      className="k-form-error k-invalid-msg"
      style={{ visibility: IsError ? "" : "hidden" }}
    >
      {text}
    </span>
  );
};

export const ErrorMsg = ({ text }) => {
  return <span className="k-form-error k-invalid-msg">{text}</span>;
};

export const confirmDelete = (callback) => {
  const modal = new bootstrap.Modal(document.getElementById("delete-dialog"));
  modal.show();
  const confirm = document.getElementById("btn-delete-confirm");
  confirm.onclick = () => {
    callback();
  };
};

export const isDate = (date) => {
  const parsedDate = Date.parse(date);
  return !isNaN(parsedDate);
};

export const formatDate = (date) => {
  const d = new Date(date);

  const formattedDate = date.toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  return formatDate;
};

export const handleResize = (callback) => {
  const resizeHandler = () => {
    const width = window.innerWidth;
    callback(width);
  };

  window.addEventListener("resize", resizeHandler);

  // return () => {
  //    window.removeEventListener("resize", resizeHandler)
  // }
};

export const sessionUser = () => {
  try {
    let uId = localStorage.getItem("UserId");
    return uId || 0;
  } catch (e) {
    return 0;
  }
};

export const checkPageAccess = (menu) => {
  let hasAccess = true;
  switch (menu.toLowerCase()) {
    case "f-index":
      hasAccess = checkAccess("FEEDBACKVIEW");
      break;
    case "sales":
      hasAccess = checkAccess("DASHBOARDVIEW");
      break;
    case "revenue":
      hasAccess = checkAccess("DASHBOARDVIEW");
      break;
    case "execution":
      hasAccess = checkAccess("DASHBOARDVIEW");
      break;
    case "countlead":
      hasAccess = checkAccess("DASHBOARDVIEW");
      break;
    case "ringcentral":
      hasAccess = checkAccess("DASHBOARDVIEW");
      break;
    case "customersatisfaction":
      hasAccess = checkAccess("DASHBOARDVIEW");
      break;
    case "dashboard":
      hasAccess = checkAccess("DASHBOARDVIEW");
      break;
    case "email-configuration":
      hasAccess = checkAccess("EMAILCONFIGVIEW");
      break;
    case "app-configuration":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "banner":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "settings":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "rentalguideline":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "rentalservicedetails":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "videos":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "venueList":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "facilities":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "RentalHighlights":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "vendorservices":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "services":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "blog":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "eventtips":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "packages":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "privacyterms":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "faq":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "contact":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "aboutus":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "highlightsawards":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "upcomingevents":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "welcomesection":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "testimonials":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
    case "myballroom":
      hasAccess = checkAccess("APPCONFIGVIEW");
      break;
  }

  if (!hasAccess) {
    window.history.replaceState(null, "", window.location.href);
    window.location.href = LoginURL;
  }
  return hasAccess;
};

export const checkAccess = (privillage) => {
  let usr = localStorage.getItem("Privillages");
  if (usr) {
    return usr.includes(privillage);
  }
  return false;
};
export const PdfModal = ({
  chart,
  modalId,
  modalTitle,
  modalcloseId,
  PDFDownload,
}) => {
  return (
    <div id={modalId} class="cmodal">
      <div class="cmodal-content">
        <div className="modal-header">
          <div
            className="ms-2 me-2 "
            title="Export to Pdf"
            style={{
              position: "relative",
              float: "right",
              cursor: "pointer",
            }}
            onClick={() => {
              PDFDownload();
            }}
          >
            <span className="files-icon">
              <i class="las la-image"></i>
            </span>
          </div>
          <span class="close" id={modalcloseId}>
            &times;
          </span>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="card-body">
              <div style={{ height: 600, fontWeight: "bold" }}>
                <div style={{ textAlign: "center" }}>{modalTitle}</div>
                {chart}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const InfoIcon = ({ content = "" }) => {
  const points = content?.includes(";") ? content.split(";") : [content];

  return (
    <i
      className="k-icon k-i-information"
      title={
        points.length > 1
          ? points.map((point, index) => `• ${point.trim()}`).join("\n")
          : points[0]?.trim()
      }
      style={{
        marginLeft: "5px",
        cursor: "pointer",
        fontSize: "14px",
      }}
    ></i>
  );
};
